import { render, staticRenderFns } from "./OrganizationLicenseApply.vue?vue&type=template&id=f4f9df1a&scoped=true&"
import script from "./OrganizationLicenseApply.vue?vue&type=script&lang=js&"
export * from "./OrganizationLicenseApply.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationLicenseApply.vue?vue&type=style&index=0&id=f4f9df1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f9df1a",
  null
  
)

export default component.exports